import $ from 'jquery'

export default class {
  constructor(container) {
    this.container = container

    this.file = this.container.find('.JS-FileUpload-field')

    this.browseText = (this.file.data('browse') || 'Browse') + '...'
    this.validExtensions = (this.file.data('extensions') || '').split(' ')
    this.wrongExtensionText = this.file.data('wrong-extension') || 'Wrong extension!'

    this.file.wrap($('<div/>').addClass('btn btn-default btn-file'))

    $('<span/>')
      .text(this.browseText)
      .addClass('browse')
      .insertBefore(this.file) // formstyler?
    this.info = $('<span/>').insertBefore(this.file)

    this.file.on('change', () => {
      let fileName = this.file.val()

      if (!fileName) return null

      let isCorrect = this.checkFormat(fileName)

      let infoText =
        this.formattedFilename(fileName) + (isCorrect ? '' : ' ' + this.wrongExtensionText)

      this.info.text(infoText)
      this.info.toggleClass('error_explanation', !isCorrect)

      if (!isCorrect) this.file.val('')
    })
  }

  formattedFilename(name) {
    return name.replace(/.*(\\|\/)/, '')
  }

  checkFormat(name) {
    if (this.validExtensions.length > 0) {
      let ext = name.substring(name.lastIndexOf('.'))
      return this.validExtensions.indexOf(ext) >= 0
    } else {
      return true
    }
  }
}
